import React, { useRef, useEffect } from "react";
import Popper from "@mui/material/Popper";
import "../css/notifications.css";
import { useAppDispatch, useAppSelector } from "../store/store";
import { useNavigate } from "react-router-dom";
import { reset } from "../reducers/userReducer";
import { isEmpty, isNil } from "lodash";
import { setNavOption } from "../reducers/commonReducer";
import { SELECTED_NAV_OPTION } from "../constants/stringConstants";
interface PopOverTypes {}

export default function SimplePopperProfile(props: PopOverTypes) {
  const { profileData } = useAppSelector((state) => state["user"]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const ref = useRef<HTMLDivElement | null>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      let target = e.target as HTMLElement;
      if (target?.id === "profileId") {
        onProfileTap();
      }
      if (target?.id === "logoutId") {
        onLogoutTap();
      }

      if (target?.id === "changePasswordId") {
        onChangePassword();
      }
      onBodyClick(e);
    });

    return () => {
      document.body.removeEventListener("click", (e) => onBodyClick(e));
    };
  }, []);

  const onBodyClick = (event: globalThis.MouseEvent) => {
    if (ref.current?.contains(event.target as Node)) {
      return;
    }
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const onProfileTap = () => {
    dispatch(setNavOption(SELECTED_NAV_OPTION.PROFILE));
    navigate("/auth/profile");
  };

  const onLogoutTap = () => {
    dispatch(setNavOption(SELECTED_NAV_OPTION.JOBS));
    dispatch(reset());
    navigate("/auth/login", { replace: true });
  };

  const onChangePassword = () => {
    navigate("/changePassword");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <div ref={ref}>
      <span onClick={handleClick}>
        {!isNil(profileData?.candidate?.profilePicture) &&
        !isEmpty(profileData?.candidate?.profilePicture) ? (
          <img
            src={profileData?.candidate?.profilePicture}
            className="navbar_routes_item_icon_user"
            style={{ borderRadius: "20px" }}
          />
        ) : (
          <div
            className="navbar_routes_item_icon_user"
            style={{ borderRadius: "20px", backgroundColor: "#dbdee3" }}
          />
        )}
      </span>

      <Popper id={id} open={open} anchorEl={anchorEl}>
        <div className="toggler_container_boxStyle" style={{ marginRight: "20px" }}>
          <div
            id="profileId"
            className="popOver_container_profile"
            style={{
              borderBottom: "1px solid lightgrey",
            }}
          >
            <text id="profileId" style={{ fontSize: "15px", fontWeight: 500 }}>
              Profile
            </text>
          </div>
          {/* 
          <div
            id="changePasswordId"
            className="popOver_container_profile"
            style={{
              borderBottom: "1px solid lightgrey",
            }}
          >
            <text id="changePasswordId" style={{ fontSize: "15px", fontWeight: 500 }}>
              Change Password
            </text>
          </div> */}

          <div id="logoutId" className="popOver_container_profile">
            <text id="logoutId" style={{ fontSize: "15px", fontWeight: 500 }}>
              Logout
            </text>
          </div>
        </div>
      </Popper>
    </div>
  );
}
